<script setup lang="ts">

import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import Translator from "@/utils/common/Translator.ts";
import LoginUtils from "@/utils/login/LoginUtils.ts";
import {computed} from "vue";
import DialogHandler, {CommonDialogAction} from "@/utils/forms/DialogHandler.ts";
import {QuestionFieldsWithValues, WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import {QuestionFieldsPresenter} from "@/utils/presenters/QuestionFieldsPresenter.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";

const {isSideBarOpen} = storeToRefs(useNamaFlagsStore());
const legalEntity = computed(() => Translator.translateRef(LoginUtils.loginInfo?.dimensions?.legalEntity));

async function showDialog() {
  useNamaFlagsStore().updateInChangeDimsDialog(true);
  let okBtn: CommonDialogAction = CommonDialogAction.createOkDialogAction(async (object: Record<string, any>) => {
    useNamaFlagsStore().updateInChangeDimsDialog(false);
    await LoginUtils.onDimensionsSelected(object);
  });
  let cancelBtn: CommonDialogAction = CommonDialogAction.createCancelDialogAction(() => {
    useNamaFlagsStore().updateInChangeDimsDialog(false);
  });
  let questionFieldsWithValues: QuestionFieldsWithValues = LoginUtils.createDimensionsDialogQuestionFieldsWithDefaultValues();
  let questionPresenter: QuestionFieldsPresenter = new QuestionFieldsPresenter();
  await questionPresenter.edit(questionFieldsWithValues.questionFields ?? [], questionFieldsWithValues.defaultValues ?? []);
  let dialogBox = new DialogHandler([okBtn, cancelBtn], Translator.translateId("selectLegalEntity"));
  await dialogBox.createPresenter(questionPresenter as WidgetsPresenter);
  await dialogBox.runDialogBox();
}

</script>

<template>
  <div
    :title="Translator.translateId('loginDimensions')"
    class="tw-flex tw-justify-between tw-items-center  tw-relative tw-cursor-pointer tw-transform tw-transition-all tw-duration-1000 tw-ease-in-out"
    @click.stop="showDialog">
    <NamaIcon default-icon="nm-dimensions" class="tw-size-6 compact:tw-size-[22px] ultra:tw-size-5"/>
    <span class="tw-px-1 ultra:tw-px-0.5 tw-text-namaFontColor-header-light dark:tw-text-namaFontColor-header-dark ultra:tw-text-xs tablet:tw-hidden"
          :class="{'laptop:tw-hidden':isSideBarOpen}">{{ legalEntity }}</span>
  </div>
</template>

<style scoped>

</style>
